import FormCard from '../../inputFormComponents/FormCard'
import FormRow from '../../inputFormComponents/FormRow'
import { BooleanInput, FormDataConsumer, NumberInput, SelectInput, TextInput, required, useTranslate } from 'react-admin'
import { postCode, taxNumberAsync, ustId } from '../../validators/validate'
import DescriptionUserCompany from './descriptions/DescriptionUserCompany'
import { federalStateChoices } from './federalStateChoices'

const UserCompanyCard = () => {
  const translate = useTranslate()

  return (
    <FormCard title={translate('resources.company.userCompanyName')} 
      description={<DescriptionUserCompany />}
      rows={[
        <FormRow fields={[
          <TextInput fullWidth helperText={false} source="company.companyName" label="resources.company.userCompanyName" validate={required()} />
        ]}/>,
        <FormRow fields={[
          <TextInput fullWidth helperText={false} source="company.street" label="resources.company.street" validate={required()} />,
        ]}/>,
        <FormRow fields={[
          <TextInput sx={{minWidth:"24%"}} helperText={false} source="company.postCode" label="resources.company.postCode" validate={[required(), postCode()]} />,
          <TextInput sx={{ml:2}} fullWidth helperText={false} source="company.city" label="resources.company.city" validate={required()} />,
        ]}/>,
        <FormRow fields={[
          <BooleanInput helperText={false} source="isSmallBusiness" label="resources.users.isSmallBusiness" />,
          <NumberInput sx={{ml:2}} fullWidth helperText={false} source="defaultDuePeriod" label="resources.users.defaultDuePeriod" />
        ]}/>,
        <FormRow fields={[
          <TextInput sx={{minWidth:"60%"}} source='taxNumber' helperText={false} label="resources.users.taxNumber" validate={taxNumberAsync} />,
          <FormDataConsumer>
            {({ formData}) => (
              <SelectInput sx={{ml:2}} validate={formData.taxNumber ? required() : undefined} fullWidth source='federalState' choices={federalStateChoices} helperText={false} label="resources.users.federalState" />
            )}
          </FormDataConsumer>
        ]}
        />,
        <FormRow fields={[
          <TextInput sx={{minWidth:"60%"}} helperText={false} source="ustId" label="resources.users.ustId" validate={ustId()}/>,
          <FormDataConsumer>
            {({ formData}) => (
              <BooleanInput sx={{ml:2}} disabled={formData.ustId==null} helperText={false} source="isUstIdHidden" label="resources.users.isUstIdHidden" />
            )}
          </FormDataConsumer>
        ]}/>,
        <FormRow fields={[
          <TextInput fullWidth helperText={false} source="company.localCourt" label="resources.company.localCourt" />,
          <TextInput sx={{ml:2}} fullWidth helperText={false} source="company.hrbNumber" label="resources.company.hrbNumber" />,
          <TextInput sx={{ml:2}} fullWidth helperText={false} source="company.managingDirector" label="resources.company.managingDirector" />
        ]}/>,
        <FormRow fields={[
          <TextInput fullWidth helperText={false} source="company.email" label="resources.company.email" />,
          <TextInput sx={{ml:2}} fullWidth helperText={false} source="company.website" label="resources.company.website" />        
        ]}/>
      ]}
    />
  )
}

export default UserCompanyCard